module.exports = __webpack_public_path__ + "img/avatar7.ffe032b2.png";